import React, { useState, useEffect } from "react";
import { Card } from "antd";
import { useTemplates } from "../../../hooks/bot/useTemplates";
import TemplateSearchBar from "../../../components/bot/templates/TemplateSearchBar";
import TemplatesTable from "../../../components/bot/templates/TemplatesTable";
import TemplateModal from "./TemplateModal";
import TemplateItemsDrawer from "./TemplateItemsDrawer";

const TemplatesManagement = () => {
  // Custom hook
  const {
    filteredTemplates,
    loading,
    searchText,
    setSearchText,
    fetchTemplates,
    deleteTemplate,
    toggleTemplateStatus,
  } = useTemplates();

  // Modal states
  const [modalVisible, setModalVisible] = useState(false);
  const [itemsDrawerVisible, setItemsDrawerVisible] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  // Fetch templates on mount
  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  // Handlers
  const handleCreateTemplate = () => {
    setEditingTemplate(null);
    setModalVisible(true);
  };

  const handleEditTemplate = (template) => {
    setEditingTemplate(template);
    setModalVisible(true);
  };

  const handleManageItems = (template) => {
    setSelectedTemplate(template);
    setItemsDrawerVisible(true);
  };

  return (
    <>
      <Card title="Requirement Templates">
        <TemplateSearchBar
          searchText={searchText}
          onSearchChange={setSearchText}
          onCreateTemplate={handleCreateTemplate}
        />

        <TemplatesTable
          templates={filteredTemplates}
          loading={loading}
          onManageItems={handleManageItems}
          onEdit={handleEditTemplate}
          onDelete={deleteTemplate}
          onToggleStatus={toggleTemplateStatus}
        />
      </Card>

      {/* Template Modal */}
      <TemplateModal
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          setEditingTemplate(null);
        }}
        onSuccess={() => {
          setModalVisible(false);
          setEditingTemplate(null);
          fetchTemplates();
        }}
        template={editingTemplate}
      />

      {/* Template Items Drawer */}
      <TemplateItemsDrawer
        visible={itemsDrawerVisible}
        onClose={() => {
          setItemsDrawerVisible(false);
          setSelectedTemplate(null);
        }}
        template={selectedTemplate}
        onUpdate={fetchTemplates}
      />
    </>
  );
};

export default TemplatesManagement;
